import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/reactQueryKeys/keysFactory';
import planetApi from '@/apis/planet';

export default function PlanetEntryPage() {
  const router = useRouter();
  const { data, isLoading } = useQuery({ queryKey: queryKeys.planet.me(), queryFn: planetApi.me });

  useEffect(() => {
    if (isLoading) return;
    if (!data) return;
    if (data.hasPlanet) {
      router.replace(`/burnfi/planet/${data.planetId}`);
    } else {
      router.replace(`/burnfi/planet/mint`);
    }
  }, [data, isLoading, router]);

  return null;
}

